import { Link } from "react-router-dom";
import { useCart } from "@/lib/cart";
import { formatGBP } from "@/lib/api";
import { Trash2, Plus, Minus } from "lucide-react";

export default function CartPage() {
  const { items, subtotal, updateQty, remove } = useCart();
  return (
    <div className="bg-[#FFF4E0] min-h-[60vh]" data-testid="cart-page">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 py-16">
        <div className="overline mb-3">Step 1 of 2</div>
        <h1 className="font-serif-display text-5xl md:text-6xl text-[#1A0F11] mb-12">Your Bag</h1>
        {items.length === 0 ? (
          <div className="py-20 text-center">
            <p className="font-serif-display text-3xl text-[#1A0F11]">Your bag is empty.</p>
            <Link to="/shop" className="btn-primary mt-8 inline-flex" data-testid="cart-empty-shop-cta">Shop the edit</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            <div className="lg:col-span-8 divide-y divide-[#E8D8C8]">
              {items.map((it) => (
                <div key={it.key} className="py-6 flex gap-6">
                  <img src={it.image_url} alt={it.name} className="w-28 h-36 object-cover" />
                  <div className="flex-1">
                    <Link to={`/product/${it.slug}`} className="font-serif-display text-2xl text-[#1A0F11] hover:text-[#831132]">{it.name}</Link>
                    <div className="text-xs text-[#5C4A4D] mt-2 space-y-0.5">
                      {it.length && <div>Length: {it.length}</div>}
                      {it.texture && <div>Texture: {it.texture}</div>}
                      {it.color && <div>Colour: {it.color}</div>}
                    </div>
                  </div>
                  <div className="flex flex-col items-end justify-between">
                    <span className="font-medium text-[#1A0F11]">{formatGBP(it.price * it.quantity)}</span>
                    <div className="flex items-center border border-[#E8D8C8]">
                      <button onClick={() => updateQty(it.key, it.quantity - 1)} className="p-2 hover:bg-[#FDF1EC]" aria-label="Decrease"><Minus size={14} /></button>
                      <span className="px-3 text-sm">{it.quantity}</span>
                      <button onClick={() => updateQty(it.key, it.quantity + 1)} className="p-2 hover:bg-[#FDF1EC]" aria-label="Increase"><Plus size={14} /></button>
                    </div>
                    <button onClick={() => remove(it.key)} className="text-[#831132] flex items-center gap-1 text-xs uppercase tracking-[0.18em]" data-testid={`cart-page-remove-${it.product_id}`}><Trash2 size={14} /> Remove</button>
                  </div>
                </div>
              ))}
            </div>
            <aside className="lg:col-span-4">
              <div className="bg-[#FDF1EC] p-8">
                <h3 className="font-serif-display text-2xl text-[#1A0F11]">Summary</h3>
                <div className="mt-6 flex justify-between text-sm">
                  <span className="text-[#5C4A4D]">Subtotal</span>
                  <span className="text-[#1A0F11]">{formatGBP(subtotal)}</span>
                </div>
                <div className="mt-2 flex justify-between text-sm">
                  <span className="text-[#5C4A4D]">Shipping</span>
                  <span className="text-[#1A0F11]">at checkout</span>
                </div>
                <Link to="/checkout" className="btn-primary w-full mt-6 inline-flex" data-testid="cart-page-checkout-cta">Proceed to Checkout</Link>
                <Link to="/shop" className="btn-outline w-full mt-3 inline-flex">Continue shopping</Link>
              </div>
            </aside>
          </div>
        )}
      </div>
    </div>
  );
}
